import React from 'react';

import { Tooltip } from 'antd';
import { ClockCircleOutlined, FileOutlined, FileSyncOutlined, FileDoneOutlined, ExceptionOutlined } from '@ant-design/icons';

import { ORDER_STATUS } from '../../../utils/constants/order-status';

import './bv-order-status.scss';

interface IBVOrderStatus {
    status?: string;
    title?: string;
}

const BVOrderStatus: React.FunctionComponent<IBVOrderStatus> = ({ status, title }) => {
    const _handleStatusIcon = () => {
        let statusIcon = <FileOutlined />;

        switch (status) {
            case ORDER_STATUS.COMPLETE.code: {
                statusIcon = <FileSyncOutlined />;
                break;
            }
            case ORDER_STATUS.DRAFT.code: {
                statusIcon = <FileOutlined />;
                break;
            }
            case ORDER_STATUS.ERROR.code: {
                statusIcon = <ExceptionOutlined />;
                break;
            }
            case ORDER_STATUS.SCHEDULED.code: {
                statusIcon = <ClockCircleOutlined />;
                break;
            }
            case ORDER_STATUS.SENT.code: {
                statusIcon = <FileDoneOutlined />;
                break;
            }
        }

        return statusIcon;
    }

    return (
        <Tooltip title={title || status}>
            <span className="orders-group-item-status">
                {_handleStatusIcon()}
            </span>
        </Tooltip>
    );
}

export default BVOrderStatus;